import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { TabType } from '@domains/pdp-common';

import { Tabs } from '../components/Tabs';
import { useTabsService } from '../services/useTabsService';

interface Props {
  tabComponentList: Record<TabType, JSX.Element>;
}

export const TabsContainer: React.FC<React.PropsWithChildren<Props>> = ({ tabComponentList }) => {
  const service = useTabsService();

  return (
    <div ref={service.combindRef}>
      <Divider />
      <Tabs
        isSizeTabTooltipShown={service.isSizeTabTooltipShown}
        isZigzagApp={service.isZigzagApp}
        activeTabType={service.activeTabType}
        tabList={service.tabList}
        tabComponentList={tabComponentList}
        changeTab={service.changeTab}
        hideSizeTabTooltip={service.hideSizeTabTooltip}
      />
    </div>
  );
};

const Divider = styled.div`
  border-top: 8px solid ${vars.v3Color.gray100};
`;
